module.exports = __webpack_public_path__ + "static/media/recover_img.8a6050d7.svg";